import React from 'react'
import {
  CCol,
  CContainer,
  CRow,
} from '@coreui/react'

const Page404 = () => {
  return (
    <div className="bg-body-tertiary min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <div className="clearfix">
              <h1 className="float-start display-3 me-4">404</h1>
              <h4 className="pt-3">Page Not Found</h4>
              <p className="text-body-secondary float-start">
                The page you are looking for does not exist.
              </p>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}
Page404.getLayout = function getLayout(page) {
  return <>{page}</>;
};

export default Page404
